package ru.it_mozaika.sender.js.application.components.campaigns

import js.core.jso
import mui.material.*
import react.*
import ru.it_mozaika.components.useSnackbar
import ru.it_mozaika.sender.common.models.EmailCampaignData
import ru.it_mozaika.sender.common.models.EmailCampaignStatus
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.context.saveCampaign
import ru.it_mozaika.sender.js.application.context.useBackdrop

external interface EmailCampaignStartDialogProps : Props {
    var campaign: EmailCampaignData?
    var onClose: (isSend: Boolean) -> Unit
}
val EmailCampaignStartDialog = FC<EmailCampaignStartDialogProps> { props ->
    val backdrop = useBackdrop()
    val showNotification = useSnackbar().enqueueSnackbar
    var startTime by useState(props.campaign?.startDate)
    var intelligentSending by useState(props.campaign?.startDate != null && props.campaign?.intelligentSending == true)
    useEffect(startTime) {
        if (startTime == null) { intelligentSending = false }
    }
    useEffect(props.campaign) {
        startTime = props.campaign?.startDate
        intelligentSending = props.campaign?.startDate != null && props.campaign?.intelligentSending == true
    }

    Dialog {
        open = props.campaign != null
        onClose = { _, _ -> props.onClose(false) }
        DialogTitle { +"Запустить рассылку?" }
        DialogContent {
            DialogContentText { +"Вы уверены, что хотите ${if (props.campaign?.status == EmailCampaignStatus.Template) "запустить" else "продолжить"} массовую рассылку ${props.campaign?.name}?" }

            EmailCampaignStartParameters {
                this.disabled = props.campaign?.status != EmailCampaignStatus.Template
                this.startTime = startTime
                this.startTimeChanged = { startTime = it }
                this.intelligentSending = intelligentSending
                this.intelligentSendingChanged = { intelligentSending = it }
            }
        }
        DialogActions {
            Button {
                onClick = { props.onClose(false) }
                autoFocus = true
                size = Size.small
                +"Назад"
            }
            Button {
                onClick = {
                    props.campaign?.let { campaign ->
                        backdrop.show()
                        if (campaign.startDate != startTime || campaign.intelligentSending != intelligentSending) {
                            saveCampaign(campaign.copy(startDate = startTime, intelligentSending = intelligentSending), { error, color -> showNotification(error, jso { color?.let { variant = color } }) }) {
                                startCampaign(it) { error ->
                                    backdrop.hide()
                                    error?.let { showNotification(error, jso { variant = AlertColor.error }) }
                                    props.onClose(error == null)
                                }
                            }
                        } else {
                            startCampaign(campaign.id) { error ->
                                backdrop.hide()
                                error?.let { showNotification(error, jso { variant = AlertColor.error }) }
                                props.onClose(error == null)
                            }
                        }
                    }
                }
                variant = ButtonVariant.contained
                color = ButtonColor.secondary
                size = Size.small
                endIcon = mui.icons.material.Send.create()
                +if (props.campaign?.status == EmailCampaignStatus.Template) {
                    "Запустить"
                } else {
                    "Продолжить"
                }
            }
        }

    }
}

private fun startCampaign(id: String, callback: (error: String?) -> Unit) {
    Http.get("/campaigns/$id/start") { response ->
        callback(response.checkResponseError())
    }
}